<template>
  <div class="rt-advance-table-item">
    <el-checkbox v-bind="$attrs"> <slot /> </el-checkbox>
  </div>
</template>

<script>
export default {
  name: 'RtAdvanceTableItem'
};
</script>

<style></style>



// WEBPACK FOOTER //
// rtAdvanceTableItem.vue?25e96f65